// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sen-styles-module-list-W_jn_H9D{line-height:24px}`, "",{"version":3,"sources":["webpack://./src/components/Sensors/ActionButtons/SensorRecalibrate/styles.module.scss"],"names":[],"mappings":"AAAA,iCACE,gBAAA","sourcesContent":[".list {\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `sen-styles-module-list-W_jn_H9D`
};
export default ___CSS_LOADER_EXPORT___;
